import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './plugins/element.js'
import '@/assets/style/public.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import * as echarts from 'echarts'
import Print from 'vue-print-nb'
import qs from 'qs'
import { getDicts } from "@/utils/dict/data";
import DictTag from "@/components/DictTag"
import DictData from '@/components/DictData'
import {selectDictLabel, selectDictLabels} from "@/utils/ruoyi";
Vue.config.productionTip = false
Vue.prototype.$echarts=echarts
Vue.prototype.$qs = qs
Vue.prototype.getDicts = getDicts
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.use(VueAxios,axios)
Vue.use(Print)
Vue.component('DictTag', DictTag)
DictData.install()
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
